import type { Category, Layout, Menu, SocialMedia } from '@/interfaces/strapi';

type StrapiContext = {
	layout: Layout;
	menu: Menu;
	blogCategories: Category[];
	socialMedia: SocialMedia[];
};

const emptyStrapiContext: StrapiContext = {
	layout: {
		header: {
			logo: {
				alt: '',
				link: '',
				imageUrl: '',
			},
			image: '',
		},
		body: {
			bgImage: '',
			hasSearcherEscriturasPublicas: false,
			hasSearcherNotarios: false,
			banners: [],
		},
		footer: {
			top: {
				title: '',
				quickAccess: [],
			},
			middle: {
				map: '',
				legalText: '',
				address: {
					items: [],
				},
				menu: [],
			},
			bottom: {
				copyright: '',
				legalList: [],
				ctLogo: {
					url: '',
					alt: '',
				},
			},
		},
	},
	blogCategories: [],
	menu: {
		navItems: [],
		buttons: [],
	},
	socialMedia: [],
};

export type { StrapiContext };
export { emptyStrapiContext };
